<template>
  <div class="teams-promo-wrapper">
    <button
      @click.stop.prevent="open()"
      data-testid="invite-team-members-btn"
      class="teams-promo-button teams-promo-button--compact"
      :class="{ 'teams-promo-button-disabled': isAtUserLimit }"
    >
      <Icon name="general.plus" size="base" />
      Invite teammates
    </button>
  </div>
</template>

<script lang="ts" setup>
import { useModal } from '@/storybook/modal/useModal';
import InviteModal from '../InviteModal.vue';
import Icon from '@/storybook/icon/Icon.vue';
import { useUserSeats } from '@/composables/useUserSeats';
import './sidebar.css';

const { open } = useModal(InviteModal);
const { isAtUserLimit } = useUserSeats();
</script>

<style scoped>
.teams-promo-button-disabled {
  @apply opacity-50 cursor-pointer;
}
</style>
